import React, { Fragment } from "react";
import { arrayOf, shape } from "prop-types";
import { Container, Item } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import ProductInfoItem from "../../../../builder_portal/components/product/ProductInfoItem";
import FormatCurrency from "../../currency/FormatCurrency";
import { SubLineItemShape } from "../../configurator/roomBook.shape";
import { OptionShape } from "../../../shapes/subLineItemOption.shape";
import ProductLineLabel from "../../elements/productLineLabel";
import BreadcrumbPartials from "./breadcrumbPartials";
import { defaultRichTextTags } from "../../../../builder_portal/helpers/defaultRichTextTags";
import "./requiredProductLineUpdates.scss";

function RequiredProductLineUpdates({ productLineUpdates }) {
  return (
    <div data-component="requiredProductLineUpdates">
      <Container>
        <FormattedMessage
          id="buyerPortal.productLineUpdate.confirmationDialog.description"
          values={{
            prevLabel: (
              <ProductLineLabel
                key="oldInvalidOption"
                productLine={{
                  ...productLineUpdates[0].oldInvalidOption?.productLines?.[0],
                  active: false
                }}
              />
            ),
            nextLabel: (
              <ProductLineLabel
                key="newValidOption"
                productLine={{
                  ...productLineUpdates[0].newValidOption?.productLines?.[0],
                  active: true
                }}
              />
            ),
            ...defaultRichTextTags
          }}
        />
      </Container>
      <Item.Group>
        {productLineUpdates.map(
          ({ subLineItem, newValidOption, oldInvalidOption }, i) => {
            const totalDelta =
              (newValidOption?.total ?? 0) - (oldInvalidOption?.total ?? 0);
            return (
              <Fragment key={subLineItem.id}>
                <BreadcrumbPartials
                  lastSubLineItem={productLineUpdates[i - 1]?.subLineItem}
                  subLineItem={subLineItem}
                />
                <Item id={`product-line-update-sli-${subLineItem.id}`}>
                  <Item.Image size="tiny" src={`${newValidOption.thumbUrl}`} />
                  <Item.Content>
                    <ProductInfoItem product={newValidOption} mode="bp_card" />
                  </Item.Content>
                  <Item.Extra>
                    <FormatCurrency
                      className={totalDelta >= 0 ? "debit" : "credit"}
                      amount={totalDelta}
                      isOnRequest={newValidOption.isOnRequest}
                    />
                  </Item.Extra>
                </Item>
              </Fragment>
            );
          }
        )}
      </Item.Group>
    </div>
  );
}

RequiredProductLineUpdates.propTypes = {
  productLineUpdates: arrayOf(
    shape({
      subLineItem: SubLineItemShape,
      newValidOption: OptionShape,
      oldInvalidOption: OptionShape
    })
  )
};

RequiredProductLineUpdates.defaultProps = {
  productLineUpdates: []
};

export default RequiredProductLineUpdates;
